import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { Observable, map } from "rxjs";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";

@Injectable({
  providedIn: "root",
})
export class PlayerAlreadySelectedWS {
  constructor(private baseHandler: BaseHandler) {}

  execute(matchId: string, token: string): Observable<boolean> {
    const parameters = new HandlerBuilder()
      .setUrl(ApiUrls.PLAYER_ALREADY_SELECTED_ENDPOINT(matchId))
      .setMethod(HttpMethod.get)
      .setAuthorization(new TokenAuthorization(token))
      .build();
    return this.baseHandler
      .execute(parameters)
      .pipe(map((response) => !response.player_selected));
  }
}
